import React from 'react';
import {useRecoilValue} from 'recoil';

import {TFirebaseMediaLibraryItemReady} from '@chancer/common/lib/interfaces/firestore/FirestoreClientInterfaces';
import {mediaLibraryState} from '../../../../recoil/FirestoreRecoil';
import {CardList} from '../../../components/Layout/CardList';
import {Info} from '../../../components/Note/Info';
import {MediaListItem} from './MediaListItem';

interface IProps {
  tagsFilter?: string[];
  onCaptionSelected?: (caption: string) => void;
  onOpenGraphImageSelected?: (
    media: TFirebaseMediaLibraryItemReady,
    imageUrl: string,
  ) => void;
  onEmbedSelected?: (media: TFirebaseMediaLibraryItemReady) => void;
  onDelete?: (id: string) => void;
  onTagDelete?: (id: string | undefined, tag: string) => void;
  onTagAdd?: (id: string, tag: string) => void;
  onRegenerateCaption?: (media: TFirebaseMediaLibraryItemReady) => void;
  selectedIds?: Set<string>;
  onToggleSelect?: (id: string) => void;
}

export const MediaList: React.FC<IProps> = (props) => {
  const mediaItems = useRecoilValue(mediaLibraryState(props.tagsFilter ?? []));

  if (!mediaItems) {
    return null;
  }

  return mediaItems.length === 0 ? (
    <Info className="mt-8" message="No media items available" />
  ) : (
    <CardList className="mb-1">
      {mediaItems.map((media) => (
        <MediaListItem
          key={media.id}
          media={media}
          onRegenerateCaption={props.onRegenerateCaption}
          onCaptionSelected={props.onCaptionSelected}
          onEmbedSelected={props.onEmbedSelected}
          onOpenGraphImageSelected={props.onOpenGraphImageSelected}
          onDelete={props.onDelete}
          onTagDelete={props.onTagDelete}
          onTagAdd={props.onTagAdd}
          isSelected={props.selectedIds?.has(media.id) ?? false}
          onToggleSelect={props.onToggleSelect}
        />
      ))}
    </CardList>
  );
};
